<template>
    <div class="con">
        <div class="banner">
            <img src="../assets/yr/pbanner.png" alt="">
        </div>
        <div class="main">
            <div class="mainCon">
                <div class="nav">
                    <span @click="goto(0)">{{$t('proInfo2').text1}} /</span>
                    <span @click="goto(1)">{{$t('proInfo2').text2}} /</span>
                    <span>{{text}}</span>
                </div>
<!--                <div class="list">-->
<!--                    <span v-for="(item,index) in list" :key="index"  :class="{'showLine':num===index}" @click="showRight(index,item.ID)">{{item.CALLED}}</span>-->
<!--                </div>-->
                <div class="proList">
<!--                    <p class="title">{{text}}</p>-->
                    <div class="oneItem" v-for="(item,index) in proList" :key="index">
                        <router-link :to="{path: 'proInfo',query:{id:item.ID,tid:tid}}">
                            <img :src="`http://www.yourlonglighting.com/upload/${item.SMALLPIC}`" alt="">
                            <p class="t1">{{item.PRONAME}}</p>
                            <div class="last" style="padding-bottom: 10px;">
                                <p>{{item.TITLE2}}</p>
                                <i class="iconfont icon-youjiantou"></i>
                            </div>
                        </router-link>
                    </div>

                    <div style="width:100%;text-align: center;margin-top: 40px" @click="showMore">
                        <ban-Component :text="$t('btn')" ></ban-Component>
                    </div>
                </div>
            </div>
        </div>
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import footComponent from '../components/foot'
    import banComponent from '../components/btn'
    import {getProductstypeUrl2,getProductsUrl} from '../util/lang'
    export default {
        name: "pro",
        data(){
            return{
                text:'Products',
                tid:'',
                id:'',
                page:'',
                totalPage:'',
                num:'',
                list:[],
                proList:[]
            }
        },
        components:{footComponent,banComponent},
        watch:{
            '$route': 'go',
        },
        mounted(){
            if(this.$route.query.id!==undefined){
                this.tid=this.$route.query.id
                this.text=this.$route.query.text
                this.getProducts(this.$route.query.id)
            }
            // if(this.$i18n.locale==='en'){
            //     this.getPro('72')
            // }else{
            //     this.getPro('60')
            // }
            // if(this.$route.query.index!==undefined){
            //     this.showRight2(this.$route.query.index,this.$route.query.id,this.$route.query.text)
            // }else if(this.$route.query.id!==undefined){
            //     this.text=this.$route.query.text
            //     this.num=parseInt(this.$route.query.num)
            //     this.getProducts(this.$route.query.id)
            // }
            // else{
            //     if(this.$i18n.locale==='en'){
            //         this.getProducts('72')
            //         this.text='Products'
            //     }else{
            //         this.text='所有产品'
            //         this.getProducts('60')
            //     }
            // }
        },
        methods:{
            goto(n){
                if(n===0){
                    this.$router.push({path:'/'})
                }else {
                    this.$router.push({path:'/pro'})
                }
            },
            showMore(){
                if(this.page<=this.totalPage){
                    const url = `${getProductsUrl(this.$i18n.locale,this.id,9,this.page++)}`
                    this.$axios.get(url).then(res => {
                        this.proList=this.proList.concat(res.data.proarr)
                    })
                }else{
                    this.$notify({
                        title: 'Prompt',
                        message: 'Already loaded',
                        offset: 100
                    });
                }
            },
            // showRight(n,id){
            //     this.num=n
            //     this.id=id
            //     this.page=2
            //     this.text=this.list[n].CALLED
            //     this.$router.push({
            //         name: 'Pro',
            //         query: {id: id,text:this.text,num:n}       //   params: {toseId: toseId}
            //     })
            //     const url = `${getProductsUrl(this.$i18n.locale,id,9,1)}`
            //     this.$axios.get(url).then(res => {
            //         this.proList=res.data.proarr
            //         this.totalPage=res.data.pagershow.totalPagers
            //     })
            // },
            // showRight2(n,id,t){
            //     this.num=n
            //     this.id=id
            //     this.page=2
            //     this.text=t
            //     const url = `${getProductsUrl(this.$i18n.locale,id,9,1)}`
            //     this.$axios.get(url).then(res => {
            //         this.proList=res.data.proarr
            //         this.totalPage=res.data.pagershow.totalPagers
            //     })
            // },
            getProducts(id){
                this.id=id
                this.page=2
                const url = `${getProductsUrl(this.$i18n.locale,id,9,1)}`
                this.$axios.get(url).then(res => {
                    this.proList=res.data.proarr
                    this.totalPage=res.data.pagershow.totalPagers
                })
            },
            // getPro(id){
            //     this.$nextTick(()=>{
            //         const url = `${getProductstypeUrl2(this.$i18n.locale,id)}`
            //         this.$axios.get(url).then(res => {
            //             this.list=res.data
            //         })
            //     })
            // },
        }
    }
</script>

<style lang="scss" scoped>
    .con{
        width:100%;
        background-color: #F4F4F4;
        animation: down 2s linear;
        @keyframes down {
            from{
                transform: translateX(-30px);
            }
            to{
                transform: translateX(0);
            }
        }
        .banner{
            width:100%;
            overflow: hidden;
            img{
                width:100%;
                object-fit: cover;
                display: block;
                animation: big 1s linear forwards;
            }
            @keyframes big {
                from{
                    transform: scale(1.1);
                }
                to{
                    transform: scale(1);
                }
            }
        }
        .main{
            width:100%;
            .nav{
                width:100%;
                margin: 30px 0;
                padding-top: 40px;
                span{
                    text-transform: uppercase;
                    padding-right: 5px;
                    cursor: pointer;
                    font-family: Calibri;
                }
                span:last-child{
                    color:#F4A000;
                }
            }
            .mainCon{
                width:1280px;
                margin: 0 auto;
                padding: 40px 0;
                .list{
                    width:100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    span{
                        display: inline-block;
                        padding: 0 10px;
                        font-family: Calibri;
                        text-transform: uppercase;
                        font-size: 20px;
                        cursor: pointer;
                        transition: all 2s;
                        position: relative;
                        margin-left: 3%;
                        padding-bottom: 10px;
                    }
                    span::before{
                        position: absolute;
                        content:'';
                        display: inline-block;
                        left:0;
                        width:100%;
                        bottom:0;
                        transition: all 2s;
                        height:1px;
                        background-color: rgba(0,0,0,.1);
                    }
                    span:hover{
                        color:#F4A000;
                    }
                    span:hover::before{
                        background-color: #F4A000;
                    }
                    .showLine{
                        color:#F4A000;
                    }
                    .showLine::before{
                        background-color: #F4A000;
                    }
                }
                .proList{
                    width:100%;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    .title{
                        width:100%;
                        text-align: center;
                        font-family: Calibri;
                        font-size: 30px;
                        text-transform: uppercase;
                        border-bottom: 1px solid #E2E2E2;
                        position: relative;
                        padding-bottom: 20px;
                    }
                    .title::after{
                        position: absolute;
                        content:'';
                        display: inline-block;
                        width:20%;
                        height:2px;
                        bottom:-1px;
                        left:40%;
                        background-color: rgba(0,0,0,.5);
                    }
                    .oneItem{
                        width:30%;
                        background-color: white;
                        text-align: center;
                        cursor: pointer;
                        margin-left: 2%;
                        margin-top: 50px;
                        transition: all 1s;
                        overflow: hidden;
                        a{
                            display: inline-block;
                            width:100%;
                        }
                        img{
                            width:100%;
                            height:340px;
                            object-fit: cover;
                            transition: all 1s;
                        }
                        p{
                            text-align: left;
                            width:80%;
                            margin-left: 10%;
                            font-family:Calibri;
                            text-transform: uppercase;
                        }
                        .t1{
                            font-size: 22px;
                            margin-block-end: 0;
                            transition: all 2s;
                            display: -webkit-box;
                            height:30px;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            overflow: hidden;
                        }
                        .last{
                            width:80%;
                            margin-left: 10%;
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            i{
                                color:#696969;
                                font-size: 20px;
                                transition: all 2s;
                            }
                            p{
                                margin-block-start: 0.5em;
                                margin-left: 0;
                                color:#696969;
                            }
                        }
                    }
                    .oneItem:hover{
                        box-shadow:5px 5px 5px 5px #e2e2e2;
                        img{
                            transform: scale(1.05);
                        }
                        .t1{
                            color:#F4A000;
                        }
                        .last{
                            i{
                                color:#F4A000;
                            }
                        }
                    }
                }
                .left{
                    width:20%;
                    .info{
                        width:100%;
                        display: flex;
                        flex-direction: column;
                        border-left: 1px solid rgba(0,0,0,.1);
                        border-right: 1px solid rgba(0,0,0,.1);
                        font-family:Calibri;
                        text-transform: uppercase;
                        .one{
                            padding: 10px 10px;
                            background-color: black;
                            color:#CACACA;
                            margin-block-start: 0;
                            margin-block-end: 0;
                            font-size:28px;
                        }
                        .two{
                            width:100%;
                            display: flex;
                            flex-direction: column;
                            padding-left: 10px;
                            padding-bottom: 40px;
                            p{
                                font-size: 40px;
                                margin-block-start: 0.5em;
                                margin-block-end: 0;
                            }
                            .lines{
                                width:30%;
                                text-align: center;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                span{
                                    display: inline-block;
                                    width:12px;
                                    height:1px;
                                    background-color: rgba(0,0,0,.6);
                                    margin-top:5px;
                                }
                                .t{
                                    width:8px;
                                    background-color: rgba(0,0,0,.3);
                                }
                            }
                        }
                        .three{
                            width:80%;
                            margin-left: 30px;
                            border-bottom: 1px solid rgba(0,0,0,.1);
                            margin-block-end: 0;
                            position: relative;
                            cursor: pointer;
                            transition: all 2s;
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            flex-wrap: wrap;
                            .move{
                                transition: all 2s;
                            }
                            .wclosebtn {
                                cursor: pointer;
                                text-align: center;
                                padding-top: 10px;
                                span{
                                    vertical-align: middle;
                                }
                                .icon{
                                    position: relative;
                                    width: 35px;
                                    height: 35px;
                                    margin-left: 12px;
                                    display: inline-block;
                                    .line1,.line2{
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        display: block;
                                        width: 14px;
                                        height: 2px;
                                        margin: -1px 0 0 -7px;
                                        background-color: black;
                                        -webkit-transition: all 300ms ease-out;
                                        transition: all 300ms ease-out;
                                    }
                                    .line1{
                                        transform: rotate(90deg);
                                    }
                                    .line2{
                                        -webkit-transform:rotate(-180deg);
                                        -ms-transform: rotate(-180deg);
                                        transform: rotate(-180deg);
                                        top: 17px;
                                    }
                                }
                            }
                            .closeShow{
                                .icon{
                                    .line1{
                                        transform: rotate(0);
                                    }
                                    .line2{
                                        transform: rotate(0);
                                    }
                                }
                            }
                            .listt{
                                width:100%;
                                margin-top: -10px;
                                font-family:Calibri;
                                font-weight: lighter;
                                font-size: 12px;
                                line-height: 30px;
                                p{
                                    text-indent: 10%;
                                    overflow: hidden;
                                    transition: all 2s;
                                    text-transform: capitalize;
                                    color:black;
                                }
                                p:hover{
                                    color:#C7000C;
                                    margin-left: 15px;
                                }
                                .changeColor{
                                    color:#C7000C;
                                    margin-left: 10px;
                                }
                            }
                        }
                        .three::before{
                            position: absolute;
                            content:'';
                            left:0;
                            bottom:0;
                            height:1px;
                            background-color: #C7000C;
                            display: inline-block;
                            width:0;
                            transition: all 2s;
                        }
                        .three:hover{
                            color:#C7000C;
                        }
                        .three:hover::before{
                            width:100%;
                        }
                        .showLine{
                            color:#C7000C;
                        }
                        .showLine::before{
                            width:100%;
                        }
                        .hot{
                            width:100%;
                            .oneItem{
                                width:100%;
                                background-color: white;
                                text-align: center;
                                padding: 10px 0;
                                cursor: pointer;
                                margin-top: 30px;
                                img{
                                    width:179px;
                                    height:233px;
                                    object-fit: cover;
                                    transition: all 1s;
                                }
                                p{
                                    text-align: left;
                                    width:80%;
                                    margin-left: 10%;
                                    font-family:Calibri;
                                    text-transform: uppercase;
                                }
                                .t1{
                                    font-size: 22px;
                                    margin-block-end: 0;
                                    transition: all 2s;
                                    display: -webkit-box;
                                    height:30px;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 1;
                                    overflow: hidden;
                                }
                                .last{
                                    width:80%;
                                    margin-left: 10%;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    i{
                                        color:#696969;
                                        font-size: 20px;
                                        transition: all 2s;
                                    }
                                    p{
                                        margin-block-start: 0.5em;
                                        margin-left: 0;
                                        color:#696969;
                                    }
                                }
                            }
                            .oneItem:hover{
                                img{
                                    transform: translateY(-20px);
                                }
                                .t1{
                                    color:#C7000C;
                                }
                                .last{
                                    i{
                                        color:#C7000C;
                                    }
                                }
                            }
                        }
                    }
                }
                .right{
                    margin-left: 2%;
                    width:78%;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    .oneItem{
                        width:30%;
                        background-color: white;
                        text-align: center;
                        padding: 10px 0;
                        cursor: pointer;
                        margin-left: 2%;
                        margin-top: 30px;
                        height:340px;
                        transition: all 1s;
                        img{
                            width:179px;
                            height:233px;
                            object-fit: cover;
                        }
                        p{
                            text-align: left;
                            width:80%;
                            margin-left: 10%;
                            font-family:Calibri;
                            text-transform: uppercase;
                        }
                        .t1{
                            font-size: 22px;
                            margin-block-end: 0;
                            transition: all 2s;
                            display: -webkit-box;
                            height:30px;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            overflow: hidden;
                        }
                        .last{
                            width:80%;
                            margin-left: 10%;
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            i{
                                color:#696969;
                                font-size: 20px;
                                transition: all 2s;
                            }
                            p{
                                margin-block-start: 0.5em;
                                margin-left: 0;
                                color:#696969;
                            }
                        }
                    }
                    .oneItem:hover{
                        box-shadow:5px 5px 5px 5px #e2e2e2;
                        .t1{
                            color:#C7000C;
                        }
                        .last{
                            i{
                                color:#C7000C;
                            }
                        }
                    }
                }
            }
        }
        @media screen and (max-width:450px){
            .banner{
                img{
                    height:300px;
                }
            }
            .main{
                width:95%;
                margin-left: 2.5%;
                .mainCon{
                    width:100%;
                    flex-direction: column;
                    .list{
                        flex-wrap: wrap;
                        span{
                            width:45%;
                            padding: 10px 0;
                            text-align: center;
                            font-size: 18px;
                            margin-top: 10px;
                        }
                    }
                    .proList{
                        .title{
                            font-size: 25px;
                        }
                        .oneItem{
                            width:100%;
                            margin-left: 0;
                        }
                    }
                }
            }
        }
    }
</style>
